import React from "react";
import agentImg from "../assets/dp.jpg"; // Ensure correct path
import logo from "../assets/logo.jpg";

const About = () => (
  <section
    id="about"
    className="bg-white min-h-screen flex items-center justify-center px-6 md:px-24 py-20"
  >
    <div className="flex flex-col-reverse md:flex-row items-center gap-14 max-w-6xl mx-auto">
      {/* Left: Text */}
      <div className="w-full md:w-1/2 text-center md:text-left animate-fade-in-up">
        <h1 className="text-4xl md:text-5xl font-serif font-extrabold mb-6 text-gray-900">
          Hi, I’m <span className="text-[#b87b53]">Devan Arora.</span>
          {/* <h3 className="text-3xl pt-4 md:text-4xl font-serif font-bold text-gray-900 flex items-center">
            <img
              src={logo}
              alt="Remax Logo"
              className="h-16 mr-2" // Adjust height as needed
            />
            <span className="text-gray-900">- Realtor</span>
          </h3> */}
        </h1>

        <p className="text-gray-700 leading-relaxed mb-6">
          With years of real estate service under my belt, I can assure you that
          you are in good hands with me. Representing local and future
          homeowners, I am committed to listening to my clients, focusing on
          their needs and using keen negotiating skills to ensure a successful
          transaction.
        </p>
        <p className="text-gray-700 leading-relaxed mb-8">
          My intimate knowledge of this region, and my experiences of having
          lived here all of my life, give me an enthusiasm and a desire to make
          my home, your home. I look forward to working with you!
        </p>
        <div className="flex justify-center md:justify-start gap-4">
          {/* <button className="bg-[#b87b53] text-white px-6 py-2 rounded-full shadow-md hover:bg-[#a26a45] transition-all duration-300">
            CLIENT REVIEWS
          </button> */}
          <a
            href="https://wa.me/16475504350?text=Hello%2C%20I%E2%80%99m%20interested%20in%20learning%20more%20about%20your%20real%20estate%20offerings.%20Can%20you%20help%20me%3F"
            target="_blank"
            rel="noopener noreferrer"
            className=" text-white px-6 py-2 rounded-full shadow-md hover:bg-[#a26a45]  bg-[#b87b53]  font-medium hover:underline transition-all duration-200 cursor-pointer"
          >
            CONTACT ME
          </a>
        </div>
      </div>

      {/* Right: Image with frame effect */}
      <div className="w-full md:w-1/2 relative animate-fade-in">
        <div className="absolute -left-6 -bottom-6 w-full h-full bg-gray-200 rounded-md z-0"></div>
        <img
          src={agentImg}
          alt="Agent"
          className="relative z-10 rounded-md w-full object-cover shadow-lg"
        />
      </div>
    </div>
  </section>
);

export default About;
